<template lang="">
  <div>
    <div class="search ">
      <el-form :model="searchForm" class="demo-form-inline" size="small" label-width="80px">
        <el-col :span="5"  class="formWidth">
          <el-form-item label="公司名称">
            <el-input v-model="searchForm.company" placeholder="公司名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5"  class="formWidth">
          <el-form-item label="联系人">
            <el-input v-model="searchForm.linkman" placeholder="联系人姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6"  class="formWidth">
          <el-form-item label="联系电话">
            <el-input v-model="searchForm.linkphone" placeholder="联系电话"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" class="formWidth">
          <el-form-item label="公司规模">          
            <el-select v-model="searchForm.size" clearable placeholder="公司规模">
              <el-option v-for="item in companySize" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2"  style="text-align: right;" class="formWidth">
          <el-form-item label-width="15px">
            <el-button type="primary" @click="search()"><i class="fa fa-search"></i> 查 询</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="12"  class="formWidth">
          <el-form-item label="" label-width="0px">          
            <el-radio-group v-model="searchForm.status">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button v-for="item in statusList" :key="item.id" :label="item.id">{{item.name}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="3" class="formWidth" style="float: right;text-align: right;;">
          <el-form-item label="" label-width="0px">
            <el-dropdown >
              <el-button type="primary" size="small">
                批操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>黄金糕</el-dropdown-item>
                <el-dropdown-item>狮子头</el-dropdown-item>
                <el-dropdown-item>螺蛳粉</el-dropdown-item>
                <el-dropdown-item>双皮奶</el-dropdown-item>
                <el-dropdown-item>蚵仔煎</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item> -->
          
        </el-col>
        
        <div class="clear"></div>
      </el-form>

    </div>
    <div class="clear"></div>
    <!-- <hr /> -->

    <div class="list ">
        <ul v-loading="loading">
          <li v-for="item in list">
            <div class="list_left" v-if="item.status==1">
              <!-- <div class="checkbox"><el-checkbox :v-model="false">&nbsp;</el-checkbox></div> -->
              <div class="logo">
                <el-avatar class="avatar" :size="50" :src="imgBase+item.filephoto" fit="cover"></el-avatar>
              </div>
              <div class="info">
                <p>                  
                  <span><i class="fa fa-bookmark" title="企业id"></i>{{item.id}}</span>
                  <span class="" title="注册人"><i class="fa fa-user"></i>{{item.name}} <i v-if="regInfo.gender==1" title="男" class="fa fa-mars"></i><i v-if="regInfo.gender==2" title="女" class="fa fa-venus"></i></span>
                  <b><span class="" title="注册手机"><i class="fa fa-mobile"></i>{{item.mobile|filterMobile}}</span></b>
                  <b>
                    <span class="" title="认证状态"><i class="fa fa-certificate"></i>{{item.status|filterStatus}}</span>
                  </b>
                </p>
                <p>
                  <b><span class="" title="部门"><i class="fa fa-cubes"></i>{{item.department}}</span> 
                  <span class="" title="职位"><i class="fa fa-id-card-o"></i>{{item.position}}</span></b>
                </p>
              </div>
            </div>
            <div class="list_left" v-else>
              <!-- <div class="checkbox"><el-checkbox :v-model="false">&nbsp;</el-checkbox></div> -->
              <div class="logo">
                <el-image v-if="item.filelogo" style="max-width: 100px; max-height: 100px" :src="imgBase+item.filelogo" fit="scale-down"></el-image>
                <el-avatar v-else class="avatar" :size="50" :src="imgBase+item.filephoto" fit="cover"></el-avatar>
              </div>
              <div class="info">
                <p>                  
                  <span><i class="fa fa-bookmark" title="企业id"></i>{{item.id}}</span>
                  <span class="" title="公司名称"><i class="fa fa-bank"></i>{{item.company}}</span>
                  <b><span class="" v-if="item.abbreviation" title="公司简称"><i class="fa fa-home"></i>{{item.abbreviation}}</span></b>
                  <b><span class="" v-if="item.size" title="规模"><i class="fa fa-group"></i>{{item.size}}</span>
                    <span class="" title="认证状态"><i class="fa fa-certificate"></i>{{item.status|filterStatus}}</span>
                  </b>
                </p>
                <p>
                  <b>
                    <span v-if="item.linkman" class="" title="联系人姓名"><i class="fa fa-user"></i>{{item.linkman}}</span> 
                    <span v-else class="" title="注册人"><i class="fa fa-user"></i>{{item.name}}</span> 
                    <span v-if="item.linkphone" class="" title="联系人电话"><i class="fa fa-phone"></i>{{item.linkphone|filterMobile}}</span>
                    <span v-else class="" title="注册手机"><i class="fa fa-mobile"></i>{{item.mobile|filterMobile}}</span>
                  </b>
                </p>
              </div>
            </div>
            <div class="list_right">
              <el-button size="mini" @click="getRegInfo(item.id)">查看注册资料</el-button>
              <el-button size="mini" v-if="item.status!=1" @click="getComInfo(item.id)">查看企业资料</el-button>
              <el-button size="mini" v-if="item.status==2" @click="setPass(item.id,item.company)" type="success" plain>认证通过</el-button>
              <el-button size="mini" v-if="item.status==2" @click="setUnPass(item.id,item.company)" type="primary" plain>认证不通过</el-button>
            </div>
          </li>
        </ul>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="total" :current-page="page" @current-change="current_change" :page-size="searchForm.length"></el-pagination>
    </div>

     <!-- 查看注册资料 -->
    <el-dialog title="查看注册资料" :visible.sync="regInfoDialog" :width="dialogWidth1">
      <div class="regInfo">
        <div class="regInfo_img">
          <el-avatar v-if="regInfo.filephoto" :size="100" class="avatar" :src="imgBase+regInfo.filephoto" fit="cover"></el-avatar>
        </div>
        <div class="regInfo_text">
          <p>
            <span class="">
              <i class="fa fa-user"></i>{{regInfo.name}}
              <i v-if="regInfo.gender==1" title="男" class="fa fa-mars"></i><i v-if="regInfo.gender==2" title="女" class="fa fa-venus"></i>
            </span>          
          </p>
          <p><span class="" title=""><i class="fa fa-mobile"></i>{{regInfo.mobile}}</span></p>
          <p>
            <span class="" title=""><i class="fa fa-cubes"></i>{{regInfo.department}}</span>
            <span class="" title=""><i class="fa fa-id-card-o"></i>{{regInfo.position}}</span>
          </p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="regInfoDialog=false"><i class="fa fa-times"></i> 关 闭</el-button>
      </div>      
    </el-dialog>

    <!-- 查看企业资料 -->
    <el-dialog title="查看企业资料" :visible.sync="compInfoDialog" :width="dialogWidth2" top="5vh">
      <div class="compInfo">
        <el-alert v-if="certForm.status==4" :title="'认证不通过的原因：'+certForm.cause" type="error" :closable="false" style="margin-bottom:20px;"></el-alert>
        <el-alert v-if="certForm.status==3" title="已通过企业认证" type="success" :closable="false" style="margin-bottom:20px;"></el-alert>
        <el-alert v-if="certForm.status==2" title="正在进行企业认证" type="warning" :closable="false" style="margin-bottom:20px;"></el-alert>

        <el-form ref="certForm" :model="certForm" label-width="130px" size="small">
          <el-form-item label="公司名称" class="formWidth">
            <el-input v-model="certForm.company" :disabled=true ></el-input>
          </el-form-item>
          <el-form-item label="公司简称" class="formWidth">
            <el-input v-model="certForm.abbreviation" :disabled=true></el-input>
          </el-form-item>
          <el-form-item label="企业logo" class="formWidth">
            <el-image v-if="certForm.filelogo" class="avatar" :src="imgBase+certForm.filelogo" fit="scale-down"></el-image>
          </el-form-item>
          <div class="clear"></div>
          <el-form-item label="公司规模" class="formWidth">
            <el-select v-model="certForm.size" placeholder="请选择" :disabled=true>
              <el-option v-for="item in companySize" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司地址">           
            <el-col :span="9" style="padding-right:5px;">
              <el-form-item>
                <el-cascader :options="areaOptions" style="width:100%" v-model="certForm.areaCode" :disabled=true></el-cascader>
              </el-form-item>
            </el-col>          
            <el-col :span="15" style="padding-left:5px;">
              <el-form-item :disabled=true>
                <el-input v-model="certForm.address" placeholder="请输入详细地址" :disabled=true></el-input>
              </el-form-item>
            </el-col>          
          </el-form-item>
          <el-form-item label="所属行业" class="formWidth">
            <el-cascader :options="industryOptions" style="width:100%" v-model="certForm.industryArr" :disabled=true></el-cascader>
          </el-form-item>
          <el-form-item label="公司简介">
            <el-input type="textarea" rows="5" v-model="certForm.introduction" placeholder="" :disabled=true></el-input>
          </el-form-item>
  
          <el-form-item label="联系人" class="formWidth">
            <el-input v-model="certForm.linkman" placeholder="" :disabled=true></el-input>
          </el-form-item>
          <el-form-item label="联系电话" class="formWidth">
            <el-input v-model="certForm.linkphone" placeholder="" :disabled=true></el-input>
          </el-form-item>
          <el-form-item label="联系邮箱" class="formWidth">
            <el-input v-model="certForm.linkemail" placeholder="" :disabled=true></el-input>
          </el-form-item>
  
          <div class="clear"></div>
          <el-form-item label="营业执照">
            <el-image v-if="certForm.fileone" class="avatar" :src="imgBase+certForm.fileone" fit="scale-down"></el-image>
          </el-form-item>
          <!-- <div class="clear"></div>
          <el-form-item label="税务登记证">
            <el-image v-if="certForm.filetwo" class="avatar" :src="imgBase+certForm.filetwo" fit="scale-down"></el-image>
          </el-form-item>
          <div class="clear"></div>
          <el-form-item label="组织机构代码">
            <el-image v-if="certForm.filethree" class="avatar" :src="imgBase+certForm.filethree" fit="scale-down"></el-image>
          </el-form-item>
          <div class="clear"></div>
          <el-form-item label="一般纳税人证明">
            <el-image v-if="certForm.filefour" class="avatar" :src="imgBase+certForm.filefour" fit="scale-down"></el-image>
          </el-form-item>
          <el-form-item label="需要的服务">
            <el-input v-model="certForm.helpinfo" placeholder="" :disabled=true></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="compInfoDialog=false"><i class="fa fa-times"></i> 关 闭</el-button>
      </div>      
    </el-dialog>



  </div>

 


</template>
<script>
  import * as API from '@/api/main'
  import areaJs from '@/assets/js/select_area.js';
  import industryJs from '@/assets/js/select_industry.js';
export default {
  data(){
    return {
      loading:false,
      imgBase:this.$store.state.imgBaseUrl,//图片前缀
      total:0,//总条数
      page:1,
      length:10,
      searchForm:{
        company:"",
        status:"",
        linkphone:"",
        linkman:"",
        size:"",
        page:"",
        length:"",
      },
      list:[],//列表
      companySize:["1-10人","11-50人","51-100人","101-499人","500-2000人","2000-10000人","10000人以上"],
      statusList:[{id:1,name:"未认证"},{id:2,name:"认证中"},{id:3,name:"已认证"},{id:4,name:"认证失败"}],
      regInfoDialog:false,
      compInfoDialog:false,
      regInfo:{},//注册资料
      certForm:{
        areaCode:[],
        industryArr:[],
      },//企业资料
      areaOptions: areajson, //调用外部js文件的json数据
      industryOptions:industryjson,//行业数据
      dialogWidth1:"500px",
      dialogWidth2:"1000px",
    }
  },
  filters:{

    filterStatus(value){
      let str = "";
      switch (Number(value)) {
        case 1:
          str = "未认证";
          break;
        case 2:
          str = "认证中";
          break;
        case 3:
          str = "已认证";
          break;
        case 4:
          str = "认证失败";
          break;
      }
      return str;
    },    

    filterMobile(value){
      var tel = value;
      tel = "" + tel;
      var ary = tel.split("");
      ary.splice(3,4,"****");
      var tel1=ary.join("");
      return tel1;
    },


  },
  watch:{

    "searchForm.status":{
      handler: function() {
        this.search()
      },      
    }

  },
  methods: {
    
    //获取列表
    getlist(){
      this.loading=true;
      this.searchForm.page=this.page;
      this.searchForm.length=this.length;
      API.GetCompanyList(this.searchForm).then(res=>{
        this.list=res.data.data;
        this.loading=false;
        this.total=res.data.total;
      })
    },

    //分页
    current_change(currentPage){
      // console.log(currentPage)
      this.page = currentPage;
      this.getlist();
    },

    //查询
    search(){
      // this.page=1;
      this.current_change(1);
    },

    //查看注册资料
    getRegInfo(id){
      API.GetCompanyDetailInfo({id:id}).then(res=>{
        this.regInfo=res.data;
        this.regInfoDialog=true;
      })
    },

    //查看企业资料
    getComInfo(id){
      API.GetCompanyDetailInfo({id:id}).then(res=>{
        this.certForm=res.data;
        if(this.certForm.area) this.certForm.areaCode=this.certForm.area.split(",");
        if(this.certForm.industry) this.certForm.industryArr=this.certForm.industry.split(",");        
        this.compInfoDialog=true;
      })
    },

    //认证通过
    setPass(id,name){
      this.$confirm('确定将“'+name+'”通过企业认证?', '提示', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          API.EnterPass({id:id}).then(res=>{        
            this.$message({
              message: '企业认证通过',
              type: 'success',
            })
            this.getlist();
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消认证'
          });          
        });      
    },    

    //认证不通过
    setUnPass(id,name){      
      this.$prompt('请输入验证不通过的原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern:/^[\s\S]*.*[^\s][\s\S]*$/,
          inputErrorMessage: '必须输入原因'
        }).then(({ value }) => {
          API.EnterUnpass({id:id,cause:value}).then(res=>{        
            this.$message({
              message: '企业认证不通过',
              type: 'warning',
            })
            this.getlist();
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消认证'
          });       
        });
    },

    diffrentScreen(){
      if(document.body.clientWidth<1200){
        this.dialogWidth1="100vw";
        this.dialogWidth2="100vw";
      }
    }



  },
  created() {
    this.getlist();
    this.diffrentScreen();
  },

}
</script>
<style scoped>
  .search{padding-bottom:20px;border-bottom: 1px #eee solid;}
.list {line-height: 2;;}
.list ul li{display:flex;justify-content:space-between;align-items:center;padding:10px;border-bottom: 1px solid #e7e7e7;}
.list ul li:nth-of-type(even){    background: #f6f6f6;}
.list ul li:hover{background:var(--mainColorOp)}
.list .list_left{display: flex;}
.list .list_left .checkbox{margin-right:5px;}
.list span{margin-right:1em;}
.list i.fa{color:var(--mainColor);margin-right:5px;width:16px;text-align: center;display: inline-block;}
.list span.workname{font-size:1em;}
.list span.workprize u{color:#999;}
.regInfo{display: flex;padding:0 30px;}
.regInfo_text{padding-left:20px;line-height: 2;padding-top:5px;}
.regInfo i.fa{color:var(--mainColor);margin-right:5px;width:16px;text-align: center;display: inline-block;}
.regInfo span{margin-right:1em;}
.compInfo{height:75vh;overflow-y: auto;}
.list .logo{max-height:100px;width:100px;padding:0 15px 0 5px;text-align: center;}
.list .logo .avatar{margin:0;}
.list .logo img{display: block;}
@media screen and (max-width: 1200px){
  .formWidth{width:100%;}
  .list ul li{display: block;}
  .list .list_left{flex-wrap:wrap;}
  .list_right{padding-left:0px;padding-top:1em;}
  .list b{display:block;}
  .list .info{padding-left:0px;}
  .list .logo{height:100px;width:100px;}
.formWidth{width:100%;display:block;}
}
</style>